import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";


export default function LiteExportPDF(props) {
    let exportIcon = require("images/lite/icons/export-icon.png");
    exportIcon = <img className="export-icon" src={`/datapulse${exportIcon}`} />
    // get todays date in the format of YYYY-MM-DD
    const today = new Date().toISOString().slice(0, 10);
    const pdfTitle = `${props.companyName}-${props.dashName}-${today}.pdf`;
    
    const takeScreenshot = async (type = 'jpeg') => {
        const element = document.querySelector('.lite-dashboard'); // Capture the div with class 'lite-dashboard'
        const exportIconContainer = document.querySelector('.export-icon-container');

        if (element) {
            document.body.style.cursor = 'wait';
            exportIconContainer.style.cursor = 'wait';
            document.body.offsetHeight;

            const refreshContainer = document.querySelector('.lite-refresh-container');
            const refreshButton = document.querySelector('.lite-refresh-button');
            const headerButton = document.querySelector('.dashboard-header-button');
            const l60d = document.querySelectorAll('.l60d');


            if (refreshContainer) refreshContainer.classList.add('no-export');
            if (refreshButton) refreshButton.classList.add('no-export');
            if (headerButton) headerButton.classList.add('no-export');
            if (l60d) l60d.forEach((el) => el.classList.add('no-export'));
            if (exportIconContainer) exportIconContainer.classList.add('no-export');
    
            const bodyStyles = getComputedStyle(document.body);
            const backgroundColor = bodyStyles.getPropertyValue('background-color').trim();
            
            const fixedWidth = 1650;
    
            // Take screenshot using html2canvas
            const canvas = await html2canvas(element, {
                backgroundColor, // Ensure the entire background gets the right color
                windowWidth: fixedWidth, // Force a fixed width
                window: element.offsetWidth,
                ignoreElements: (el) => el.classList.contains('no-export') || el.classList.contains('chevpdf') 
            });
    
            // Define margins
            const marginTop = 50; // Top margin
            const marginSide = 50; // Left and right margins
            const marginBottom = 0; // No bottom margin
    
            // Create a new canvas that includes margins
            const newCanvas = document.createElement('canvas');
            newCanvas.width = canvas.width + (2 * marginSide); // Add the margin to both left and right
            newCanvas.height = canvas.height + marginTop; // Add the margin to both top and bottom
    
            const context = newCanvas.getContext('2d');
    
            // Fill the new canvas with background color
            context.fillStyle = backgroundColor;
            context.fillRect(0, 0, newCanvas.width, newCanvas.height);
    
            // Draw the original canvas onto the new one, centered within the margins
            context.drawImage(canvas, marginSide, marginTop); // Draw with the fixed margin applied on all sides
    
            const imageData = newCanvas.toDataURL(`image/${type}`);
    
                // Create a PDF using jsPDF, but dynamically set the height
                const pdfWidth = 210; // A4 width in mm
                const pdfHeight = (newCanvas.height * pdfWidth) / newCanvas.width; // Dynamically set the height
    
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: [pdfWidth, pdfHeight], // Set the page size based on the canvas height
                });
    
                // Add the entire canvas as an image to the PDF
                pdf.addImage(imageData, 'JPEG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
                pdf.save(pdfTitle)
            
        } else {
            console.error('No element found with class "lite-dashboard"');
        }
        document.body.style.cursor = 'default';
        exportIcon.style.cursor = 'pointer';
    };

return (
    <div className="export-icon-container" onClick={() => takeScreenshot('pdf')}>
      {exportIcon}
    </div>
  );
}
